export default {
    API_ENDPOINT: `https://salty-journey-67120.herokuapp.com/api`,
  }